import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'; // Import de PropTypes

import { Helmet } from 'react-helmet';

const ZohoSurvey = ({ user }) => {
  const broadcastProvider = ['AZ']; // provider scope
  const broadcastCountry = ['FR', 'ES', 'IT', 'PT']; // country scope
  const endDate = new Date('2026-06-26'); // end date
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if popup should be displayed
    const shouldDisplayPopup =
      user.email !== undefined &&
      broadcastProvider.includes(user.provider) &&
      broadcastCountry.includes(user.country) &&
      new Date() < endDate;
    setShowPopup(shouldDisplayPopup);
  }, [user.email, user.provider, user.country]);

  let zohoSurveyCode = '';
  let zohoSurveyId = '';

  switch (user.country) {
    default:
    case 'FR':
      zohoSurveyCode = '1dBa7i';
      zohoSurveyId = '103946000002473926';
      break;
    case 'ES':
      zohoSurveyCode = '2mBaHi';
      zohoSurveyId = '103946000002476802';
      break;
    case 'PT':
      zohoSurveyCode = 'jHBaDR';
      zohoSurveyId = '103946000002478293';
      break;
    case 'IT':
      zohoSurveyCode = 'vSBaRe';
      zohoSurveyId = '103946000002475339';
      break;
  }
  if (!showPopup) return null;

  return (
    <Helmet>
      <style type="text/css">{`
            iframe#zsitc_frame{
                display:block;
            }
            .sCWrap {
                width: 80vw !important;
                max-width: 760px !important;
            }

            .sCWrap .popOutiframe {
                height: 80vh;
            }
         `}</style>
      <script type="text/javascript">
        {`
(function(w,d,s,u,f,m,n,o){
o='https://survey.zohopublic.eu';
w[f]=
w[f] || 
function(){
(w[f].p=w[f].p||[]).push(arguments);
};
m=d.createElement(s),n=d.getElementsByTagName(s)[0];
m.async=1;
m.src=o+u;
n.parentNode.insertBefore(m,n);
zs_intercept(o,
"${zohoSurveyCode}?az_mail=${user?.email}",
{
"minHeight":350,
"closeView":1,
"heightType":1,
"maxHeight":700,
"position":2,
"hideEndPage":true,
"vMaps":[
{
"var_type":0,
"c_var_id":"${zohoSurveyId}",
"var_name":"az_email" 
}]});})
(window, 
document, 
'script', 
'/api/v1/public/livesurveys/${zohoSurveyCode}/popup/script', 
'zs_intercept'
);
`}
      </script>
    </Helmet>
  );
};

// Validation des props
ZohoSurvey.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
  }).isRequired,
};

export default ZohoSurvey;
